<div [cdkTrapFocusAutoCapture]="true" cdkTrapFocus>
	<modal-header-default
		[options]="{
			headerTitleKey: null,
			headerTitle: ('payment_processing' | translate)
		}"
		class="border"></modal-header-default>
	<div class="wrapper">
		<loading-spinner class="spinner green loader-big no-padding"></loading-spinner>
		<div class="processing"> {{ "processing" | translate }}</div>
		<div class="text-item"> {{ "take_few_seconds" | translate }}</div>
		<div class="text-item"> {{ "payment_dont_close_tab" | translate }}</div>
	</div>
</div>
